import React, { Component } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import {numberFormat} from "../../../../../../services/helpers";
import { selectDefTableSize } from '../../../../../../selectors/screenSelectors';
import { connect } from 'react-redux';
import CheckboxFilter from "../../../../../common/table/Checkbox";
import createSelect from '../../../../../common/table/createSelect';
import NumberInput from '../../../../../common/table/NumberInput';
import StringInput from '../../../../../common/table/StringInput';

const typeRegister = [
    { value: '1', label: 'Кошти' },
    { value: '2', label: 'Літри' },
];

const typePaymentList = [
    { value: 1, label: 'Відомість Д' },
    { value: 0, label: 'Готівковий розрахунок' },
];

class Table extends Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    render(){
        const { defaultPageSize } = this.props;
        return (
            <div className={`table-main-wrap mt-50 ${!this.props.propsArray.length && this.props.propsGetDataStatus == 'pending' ? 'table-main-wrap_loading' : '' }`}>
                <div className="table-header">Інформація про компанії</div>
                <ReactTable
                    getTheadFilterThProps={(rowInfo) => {
                        return {
                            style: {
                                overflow: 'visible',
                                textAlign: 'left'
                            }
                        }
                    }}
                    getTrProps={(state, rowInfo) => {
                        if (rowInfo && rowInfo.row) {
                            return {
                                onClick: () => {
                                    this.props.propsRowClick({
                                        id: rowInfo.row._original.ID,
                                        index: rowInfo.index
                                    });
                                },
                                style: {
                                    backgroundColor: rowInfo.index === this.props.index ? '#B8B8B8' : 'white',
                                    color: rowInfo.index === this.props.index ? 'white' : 'black',
                                    cursor: 'pointer'
                                }
                            }
                        }else{
                            return {}
                        }
                    }}
                    data={this.props.propsArray}
                    columns={[
                        {
                            Filter: StringInput,
                            id: 'Name',
                            Header: "Назва компанії",
                            accessor: "Name",
                        },
                        {
                            Filter: StringInput,
                            id: 'Address',
                            Header: "Адреса",
                            accessor: "Address"
                        },
                        {
                            Filter: createSelect({ options: typeRegister, placeholder: 'Виберіть'}),
                            minWidth: 150,
                            id: 'TypeRegisterID',
                            Header: "Тип обліку",
                            accessor: "TypeRegister.RegisterName"
                        },
                        {
                            Filter: NumberInput,
                            Header: "Кількість ліміту",
                            id: "Limit",
                            className: "rightAlign",
                            accessor: item => {
                                return item.Limit == null ? '-------------' : numberFormat(item.Limit)
                            }
                        },
                        {
                            Filter: createSelect({ options: this.props.typeTerm, placeholder: 'Виберіть'}),
                            Header: "Термін ліміту",
                            id: "TypeTermID",
                            minWidth: 150,
                            className: "rightAlign",
                            accessor: item => {
                                return item.TypeTerm == null ? '-------------' : item.TypeTerm.TermName
                            }
                        },
                        {
                            Filter: createSelect({ options: typePaymentList, placeholder: 'Виберіть'}),
                            Header: "Форма оплати",
                            id: "TypePaymentID",
                            minWidth: 230,
                            className: "rightAlign",
                            accessor: item => {
                                return item.TypePayment == null ? '-------------' : item.TypePayment.PaymentName
                            }
                        },
                        {
                            Filter: CheckboxFilter,
                            Header: "Заблоковано",
                            id: "Closed",
                            accessor: item => {
                                return <input type="checkbox" checked={item.Closed ? true : false} readOnly/>
                            }
                        }
                    ]}
                    defaultPageSize={defaultPageSize}
                    className=" -highlight"
                    pageSize={this.props.pageSize}
                    page={this.props.page}
                    onPageSizeChange={this.props.handleChangePageSize}
                    onPageChange={this.props.handleChangePage}
                    manual={true}
                    filterable
                    sortable
                    multiSort
                    onFilteredChange={this.props.handleOnFilterChange}
                    onSortedChange={this.props.handleOnSortChange}
                    filtered={this.props.filtered}
                    sorted={this.props.sorted}
                    pages={Math.ceil(this.props.count / this.props.pageSize)}
                    NoDataComponent={() => null}
                    previousText="Назад"
                    nextText="Вперед"
                    rowsText="рядків"
                    pageText="Сторінка"
                    ofText="з"
                />
                <div className="loading"></div>
            </div>
        )

    }
}

const mapStateToProps = state => ({
    defaultPageSize: selectDefTableSize(state),
    typeTerm: typeof state.user.data.typeTermList != "undefined" ? state.user.data.typeTermList: [],
});

export default connect(mapStateToProps)(Table);
